module.exports = __webpack_public_path__ + "static/media/14.1d6bde0f.jpg";